<template>
  <div class="container">
    <wrap-container class="w100">
      <footer>
        <wrap-container class="grid-container grid-container--6-6">
          <div class="logo col1">
            <img
              height="20"
              width="65"
              src="@/assets/img/logo.svg"
              alt="BBVA"
            />
          </div>
          <nav class="social-nav col2">
            <ul class="social-icons">
              <li>
                <social-icon
                  class="icon"
                  type="facebook"
                  title="BBVA Argentina en Facebook"
                  link="https://www.facebook.com/bbva.argentina"
                />
              </li>
              <li>
                <social-icon
                  class="icon"
                  type="twitter"
                  title="BBVA Argentina en Twitter"
                  link="https://twitter.com/bbva_argentina"
                />
              </li>
              <li>
                <social-icon
                  class="icon"
                  type="instagram"
                  title="BBVA Argentina en Instagram"
                  link="https://www.instagram.com/bbva_argentina/"
                />
              </li>
              <li>
                <social-icon
                  class="icon"
                  type="youtube"
                  title="BBVA Argentina en YouTube"
                  link="https://www.youtube.com/bbva_argentina"
                />
              </li>
            </ul>
          </nav>
        </wrap-container>
        <wrap-container class="grid-container grid-container--12">
          <nav class="col1">
            <ul class="footer__list">
              <li>
                <a
                  itemprop="url"
                  href="https://www.bbva.com.ar/personas/aviso-legal.html"
                  title="Aviso legal. Abre en la misma ventana."
                  aria-label="Aviso legal. Abre en la misma ventana."
                >
                  Aviso legal
                </a>
              </li>
              <li>
                <a
                  itemprop="url"
                  href="https://www.bbva.com.ar/personas/aviso-sobre-navegadores.html"
                  title="Aviso sobre Navegadores. Abre en la misma ventana"
                  aria-label="Aviso sobre Navegadores. Abre en la misma ventana"
                >
                  Aviso sobre Navegadores
                </a>
              </li>
              <li>
                <a
                  itemprop="url"
                  href="https://www.bbva.com.ar/personas/mapa.html"
                  title="Mapa. Abre en la misma ventana."
                  aria-label="Mapa. Abre en la misma ventana."
                >
                  Mapa
                </a>
              </li>
              <li>
                <a
                  itemprop="url"
                  href="https://www.bbva.com.ar/personas/recomendaciones-de-seguridad.html"
                  title="Recomendaciones de Seguridad. Abre en la misma ventana."
                  aria-label="Recomendaciones de Seguridad. Abre en la misma ventana."
                >
                  Recomendaciones de Seguridad
                </a>
              </li>
            </ul>
          </nav>
        </wrap-container>
        <wrap-container
          class="footer__disclaimer grid-container grid-container--6-6"
        >
          <p class="col1 footer__copyright">© 2020 Banco BBVA Argentina S.A.</p>
          <p class="col2 claim__content">Creando Oportunidades</p>
        </wrap-container>
      </footer>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SocialIcon from "@/components/core/SocialIcon";

export default {
  name: "AppFooter",
  components: { WrapContainer, SocialIcon }
};
</script>

<style scoped>
.container {
  background: #072146;
  color: #e4e4e4;
  font-size: 12px;
  line-height: 1.5em;
  padding: 86px 17px;
  margin-left: -17px;
  margin-right: -17px;
  text-align: justify;
  margin-bottom: 0px;
}

.grid-container {
  margin-bottom: 40px;
}

.grid-container:last-child {
  margin-bottom: 0;
}

.footer__list,
.social-nav {
  list-style: none;
  padding-left: 0;
  margin: 0;
  display: flex;
}

.footer__list a {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 13px;
  color: #5bbeff;
  letter-spacing: 0;
  line-height: 16px;
  text-decoration: none;
  display: block;
  margin-right: 24px;
}

.social-nav {
  justify-content: flex-end;
}
.social-nav .icon {
  display: block;
  margin-left: 16px;
}

.footer__copyright {
  font-family: BentonSansBBVA-Book, Helvetica, Arial, sans-serif;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;
  color: #d3d3d3;
}

.claim__content {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  color: #2dcccd;
  text-align: right;
}

.social-icons {
  list-style-type: none;
  display: flex;
  padding: 0px;
}

@media screen and (max-width: 600px) {
  .container {
    padding-top: 55px;
    padding-bottom: 55px;
  }

  footer,
  .claim__content,
  .logo,
  .footer__copyright,
  .footer__list {
    text-align: center;
  }

  .footer__list {
    display: block;
  }

  .footer__list a {
    margin-right: 0;
    margin-bottom: 30px;
  }

  .social-nav,
  .social-icons {
    justify-content: center;
  }

  .social-nav .icon {
    display: block;
    margin-right: 12px;
    margin-left: 12px;
  }

  .grid-container,
  .logo,
  .footer__copyright {
    margin-bottom: 30px;
  }

  .grid-container:last-child {
    margin-bottom: 0;
  }
}
</style>
